<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.fileType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['archType',{'initialValue': '100'}]" :trigger-change="true" dictCode="dalx" :placeholder="$t('label.pleaseSelectTheTypeOfFile')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.fileCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheFileCode')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.fileDescription')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['name', validatorRules.name]" :placeholder="$t('label.pleaseEnterTheFileDescription')" ></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('name')" :popLists="getMainTablePop('name')">
                <a-input
                  v-decorator="['name']"
                  :read-only="whetherLang('name')"
                  @click="isLangClick('name', true)"
                  :placeholder="$t('label.pleaseEnterTheFileDescription')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue, validateDuplicateValueTwoCol } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {duplicateCheck} from '@api/api'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'


  export default {
    name: 'EfsMdArchivesForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        mainTable: 'efs_md_archives',
        isCodeDisabled: false,
        // form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFileCode')},
              { validator: (rule, value, callback) => validateDuplicateValueTwoCol('efs_md_archives', 'code', value,this.model.id,
                  JSON.stringify({
                    'arch_type':this.form.getFieldValue('archType')}), callback)},
            ]
          },
          name: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFileDescription')},
            ]
          },
          validateCode(rule, value, callback) {
            let pattern = /^[a-z|A-Z][a-z|A-Z|\d|_|-]{0,}$/;
            if (!pattern.test(value)) {
              callback(this.$t('label.thePasswordEnteredTwiceIsNotTheSame'));
            } else {
              var params = {
                tableName: "efs_md_archives",
                fieldName: "code",
                fieldVal: value,
                dataId: this.model.id
              };
              duplicateCheck(params).then((res) => {
                if (res.success) {
                  callback();
                } else {
                  callback(res.message);
                }
              })
            }
          },
        },
        url: {
          add: "/areaArchive/efsMdArchives/add",
          edit: "/areaArchive/efsMdArchives/edit",
          queryById: "/areaArchive/efsMdArchives/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(this.model.id){
          this.isCodeDisabled=true
        }else{
          this.isCodeDisabled=false
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'archType','code','name','validFlag'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'archType','code','name','validFlag'))
      },
    }
  }
</script>